<template>
  <div class="md">
    <img src="~@/views/pt/images/BrowserPreview.gif"
    class="md-gif" alt="">
    <div class="md-circle"></div>
    <div id="myChart"></div>
    <div class="md-text">
      <p >平均掌握程度
        <strong class="md-text__b">{{Math.round(overallMastery[0]  * 100)}}%</strong>
      </p>
      <p class="md-text__all">平均掌握程度等于所有学生知识点平均掌握程度之和/学生总数</p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    overallMastery: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  watch: {
    overallMastery(val) {
      this.drawLiquidfill(val);
    },
  },
  mounted() {

  },

  methods: {
    drawLiquidfill(d) {
      // const progress = this.overallMasterys;
      // 基于准备好的dom，初始化echarts实例
      // const that = this;
      const hygrometer = this.$echarts.init(document.getElementById('myChart'));
      // 使用指定的配置项和数据显示图表
      const option = {
        series: [{
          type: 'liquidFill',
          radius: '100%',
          center: ['50%', '50%'],
          waveAnimation: 10, // 动画时长
          amplitude: 5, // 振幅
          data: d,
          color: ['#BFD3FF'],
          label: {
            show: false,
            normal: {
              color: '#fff',
              textStyle: {
                fontSize: 20,
                fontWeight: 'normal',
              },
            },
          },
          outline: {
            show: true,
            borderDistance: 0,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1,
            },
          },
          backgroundStyle: {
            color: '#8397FF',
          },
        }],

      };
      hygrometer.setOption(option);
    },
  },
};

</script>

<style lang="scss" scoped>
.md {
  &-circle {
    position: absolute;
    width: 101px;
    height: 101px;
    left: 82.5px;
    top: 77.5px;
    border: 4px solid #E3F1FD;
    border-radius: 50%;
  }
  &-gif {
    position: absolute;
    height: 140px;
    left: 67px;
    top: 63px;
  }
    #myChart {
      width: 100px;
      height: 100px;
      margin-left: 87px;
      margin-top: 20px;
    }
    &-text {
      position: relative;
      padding-top: 47px;
      top: -120px;
      font-size: 16px;
      font-family: 'PingFangSC-Regular', 'PingFang SC';
      left: 266px;
      font-weight: 500;
      &__b {
        color: #1989FA;
        // font-weight: 500;
      }
      &__all {
        margin-top: 15px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
</style>
